import React from 'react';
import { Card, CardContent } from './ui/card';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ hasError: true, error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-background">
          <Card className="max-w-2xl w-full bg-white/5 backdrop-blur-md border border-red-500/20">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h1 className="text-3xl font-bold text-red-400 mb-2">
                  ⚠️ Something went wrong
                </h1>
                <p className="text-muted-foreground">
                  BarsConnect encountered an error. Please refresh the page.
                </p>
              </div>
              
              {this.state.error && (
                <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 mb-4">
                  <p className="text-sm text-red-400 font-mono">
                    {this.state.error.toString()}
                  </p>
                </div>
              )}
              
              <button
                onClick={() => window.location.href = '/'}
                className="w-full bg-primary text-white px-4 py-2 rounded-md hover:bg-[hsl(var(--primary-light))]"
              >
                Reload Page
              </button>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
